<template>
    
<footer class="p-4 bg-black rounded-lg shadow  md:items-center md:justify-between md:p-6 dark:bg-gray-800">
    <span class="text-sm text-gray-500 sm:text-center dark:text-gray-400">© 2022 <a href="https://www.linkedin.com/in/ezequiel-flores-4343391a8/" class="hover:underline">Ezequiel Flores™</a>. All Rights Reserved.
    </span>
    <a href="https://gitlab.com/jeftikas/marvel" class="mr-4 hover:underline md:mr-6">Look the code of this page</a>
</footer>

        
        
    
</template>
<script>
export default {
    name: "FooterComponent",
}
</script>
<style>
    
</style>